module.exports = __webpack_public_path__ + "static/media/ckn_pedidos.4bb46285.jpg";